import InnerPageASchemes from './InnerPageASchemes';
export default InnerPageASchemes;
